<template lang="pug">
  .container(id="ScheduleDateList-container")
    .restriction-row(v-for="restriction in sortedRestrictions", :key="restriction.id", :id="'ScheduleDateList-restrictionRow' + restriction.id")
      .cell.start
        .start-stop-icon
          font-awesome-icon(icon="play")
        .p(v-if="$moment(restriction.firstPlayDate).isValid()")
          span {{  $moment(restriction.firstPlayDate).format("YYYY-MM-DD") }}
          .p &nbsp; {{  $moment(restriction.firstPlayDate).format("HH:mm") }}
        .p(v-else)
          font-awesome-icon(icon="infinity")
      .cell.stop
        .start-stop-icon
          font-awesome-icon(icon="stop")
        .p(v-if="$moment(restriction.lastPlayDate).isValid()")
          span {{ $moment(restriction.lastPlayDate).format("YYYY-MM-DD") }} &nbsp;
          .p &nbsp; {{  $moment(restriction.lastPlayDate).format("HH:mm") }}
        .p(v-else)
          font-awesome-icon(icon="infinity")
</template>

<script>
export default {
  props: ['restrictions'],
  mounted () {
  },
  data () {
    return {
      errors: {}
    }
  },
  methods: {
  },
  computed: {
    sortedRestrictions () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.restrictions
        .sort((a, b) => (a.firstPlayDate > b.firstPlayDate) ? 1 : ((b.firstPlayDate > a.firstPlayDate) ? -1 : 0))
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.container {
  width:300px;
}
.restriction-row {
  font-size: $--font-size-base;
  color: $--color-text-regular;
  display: flex;
  .cell {
    .start-stop-icon {
      min-width: 20px;
    }
    .p {
      color: $--color-text-secondary;
    }
    width: 50%;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/ScheduleDateList.vue